export enum WebStoreId {
  AT = "westfalen-at",
  BE = "westfalen-be",
  CH = "westfalen-ch",
  DE = "westfalen-de",
  FR = "westfalen-fr",
  GG_DE = "globalgas-de",
  NL = "westfalen-nl",
}

export const mapToWebStoreId = (webStoreId: string): WebStoreId | undefined => {
  if (Object.values(WebStoreId).includes(webStoreId as WebStoreId))
    return webStoreId as WebStoreId;

  // TODO: Add error handling for invalid webStoreId values, e.g. throw an error and catch it in the calling functions
  return undefined;
};
